enum RecipientTypeEnum {
    Cc = 'CC',
    To = 'TO',
}

export default RecipientTypeEnum;
